<script>
import { mapGetters } from 'vuex';
import Catalogue from '@/services/catalogue';
export default {
	data() {
		return {
			showSubMenu: false,
			showSubMenuA: false,
			showSubMenuCat: false,
			showSubMenuBuy: false,
			showSubMenuShares: false,
			showSubMenuBS: false,
			catalogue: new Catalogue(),
		}
	},
	methods: {
		toggleMenuBuy() {
			this.showSubMenuBuy = !this.showSubMenuBuy;
		},
		toggleMenu() {
			this.showSubMenu = !this.showSubMenu;
		},
		toggleMenuA() {
			this.showSubMenuA = !this.showSubMenuA;
		},
		toggleMenuCat() {
			this.showSubMenuCat = !this.showSubMenuCat;
		},
		toggleMenuShares() {
			this.showSubMenuShares = !this.showSubMenuShares;
		},
		toggleMenuBS() {
			this.showSubMenuBS = !this.showSubMenuBS;
		}
	},
	async mounted() {
		this.catalogue.get_count_bill_check();
		this.catalogue.get_count_vacations_check(this.authUser.id);
		this.catalogue.get_checks_authorize();
		this.catalogue.get_paid_checks();
		this.catalogue.get_paid_payrolls();
		this.catalogue.get_paid_shares();
		this.catalogue.get_paid_checks_tax();
		if (this.authUser.organization_charts_id == 5) {
			this.catalogue.get_buildings_resident(this.authUser.id);
		}
	},
	computed: {
		...mapGetters({
			'authUser': 'auth/user'
		})
	},
	created() {
		Event.$on("event-load-checks", () => {
			this.catalogue.get_count_bill_check();
			this.catalogue.get_paid_checks_tax();
		});
		Event.$on("event-load-pays", () => {
			this.catalogue.get_paid_checks();
			this.catalogue.get_paid_payrolls();
		});
		Event.$on("event-load-checks-approved", () => {
			this.catalogue.get_checks_authorize();
			this.catalogue.get_paid_checks();
		});
		Event.$on("event-load-checks-payroll", () => {
			this.catalogue.get_paid_payrolls();
		});
		Event.$on("event-load-checks-shares", () => {
			this.catalogue.get_paid_shares();
		});
		Event.$on("event-show-addShare", () => {
			this.catalogue.get_paid_shares();
		});
		Event.$on("event-load-bills", () => {
			this.catalogue.get_count_bill_check();
			this.catalogue.get_paid_checks_tax();
		});
		Event.$on("event-load-bills-tax", () => {
			this.catalogue.get_paid_checks_tax();
		});
		Event.$on("event-load-vacations", () => {
			this.catalogue.get_count_vacations_check(this.authUser.id);
		});
	}
}

</script>
<template>
	<nav class="mt-2">
		<ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
			<!-- Add icons to the links using the .nav-icon class with font-awesome or any other icon font library -->
			<li class="nav-item">
				<router-link :to="{ name: 'app-home' }" class="nav-link">
					<i class="nav-icon fas fa-th"></i>
					<p>
						Panel principal
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'users'">
				<router-link to="/users" active-class="active" class="nav-link">
					<i class="nav-icon fas fa-user"></i>
					<p v-if="authUser.organization_charts_id == 1 || authUser.organization_charts_id == 11">
						Usuarios
					</p>
					<p v-else>
						Proveedores
					</p>
				</router-link>
			</li>

			<!-- Propiedades -->
			<li class="nav-item" v-can="['buildings', 'departments']">
				<a href="#" class="nav-link" @click.prevent="toggleMenu">
					<i class="nav-icon fa-solid fa-city"></i>
					<p>
						<span v-if="authUser.organization_charts_id != 17">
							Propiedades
						</span>
						<span v-else>
							Departamentos
						</span>
						<i :class="showSubMenu ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenu" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">

						<li class="nav-item" v-can="'buildings'" v-if="authUser.organization_charts_id != 17">
							<router-link to="/buildings" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-building"></i>
								<p>
									Propiedades
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'departments'">
							<router-link to="/departments" active-class="active" class="nav-link">
								<i class="nav-icon fas fa-map-marker-alt"></i>
								<p>
									Indivisos
								</p>
							</router-link>
						</li>
					</ul>
				</div>
			</li>
			

			<li class="nav-item" v-if="catalogue.buildings_resident.length > 0">
				<router-link to="/petty_cash" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-cash-register"></i>
					<p>
						Caja chica
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'petty_cash'" v-if="authUser.organization_charts_id != 5">
				<router-link to="/petty_cash" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-cash-register"></i>
					<p>
						Caja chica
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'contracts'">
				<router-link to="/contracts" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-contract"></i>
					<p>
						Contratos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'contracts_bis'">
				<router-link to="/contracts_bis" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-contract"></i>
					<p>
						Contratos Bis
					</p>
				</router-link>
			</li>
			<!-- <li class="nav-item" v-can="'service_contracts'">
				<router-link to="/service_contracts" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-business-time"></i>
					<p>
						Contratos de servicios
					</p>
				</router-link>
			</li> -->
			<!-- <li class="nav-item" v-can="'banking_services'">
				<router-link to="/banking_services" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-money-check-dollar"></i>
					<p>
						Servicios bancarios
					</p>
				</router-link>
			</li> -->

			<li class="nav-item" v-can="['banking_services', 'banking_services_rules']">
				<a href="#" class="nav-link" @click.prevent="toggleMenuBS">
					<i class="nav-icon fa-solid fa-scale-balanced"></i>
					<p>
						Reglas de pago
						<i :class="showSubMenuBS ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenuBS" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">
						<li class="nav-item" v-can="'banking_services_rules'">
							<router-link to="/banking_services_rules" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-magnifying-glass-dollar"></i>
								<p>
									Reglas para pagos								
								</p>
							</router-link>
						</li>

						<li class="nav-item" v-can="'banking_services'">
							<router-link to="/banking_services" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-file-contract"></i>
								<p>
									Realizar pagos
								</p>
							</router-link>
						</li>

						
					</ul>
				</div>
			</li>


			<li class="nav-item" v-can="'rules_billing'">
				<router-link to="/rules_billing" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-contract"></i>
					<p>
						Reglas de facturación
					</p>
				</router-link>
			</li>

			<!-- Adeudos -->
			<li class="nav-item" v-can="['debts', 'invoices_issued', 'statements_accounts', 'deposits']">
				<a href="#" class="nav-link" @click.prevent="toggleMenuA">
					<i class="nav-icon fa-solid fa-scale-balanced"></i>
					<p>
						Adeudos
						<i :class="showSubMenuA ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenuA" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">

						<li class="nav-item" v-can="'debts'">
							<router-link to="/debts" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-magnifying-glass-dollar"></i>
								<p>
									Adeudos
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'invoices_issued'">
							<router-link to="/invoices_issued" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-stamp"></i>
								<p>
									Facturas emitidas
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'statements_accounts'">
							<router-link to="/statements_accounts" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-receipt"></i>
								<p>
									Estado de cuentas
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'deposits'">
							<router-link to="/deposits" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-circle-dollar-to-slot"></i>
								<p>
									Depósitos en garantía
								</p>
							</router-link>
						</li>

					</ul>
				</div>
			</li>



			<li class="nav-item" v-can="'debts_reports'">
				<router-link to="/debts_reports" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-table"></i>
					<p>
						Reporte de Adeudos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'debts_list_report'">
				<router-link to="/debts_list_report" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-list"></i>
					<p>
						Reporte de Lista
					</p>
				</router-link>
			</li>

			<li class="nav-item" v-can="'debts_list_report_month'">
				<router-link to="/debts_list_report_month" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-list"></i>
					<p>
						Reporte del mes
					</p>
				</router-link>
			</li>

			<!-- Propiedades -->
			<li class="nav-item" v-can="['concepts', 'companies', 'bank_accounts', 'checkbook']">
				<a href="#" class="nav-link" @click.prevent="toggleMenuCat">
					<i class="nav-icon fa-solid fa-book"></i>
					<p>
						Catálogos
						<i :class="showSubMenuCat ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenuCat" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">
						<li class="nav-item" v-can="'checkbook'">
							<router-link to="/checkbook" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-money-check"></i>
								<p>
									Chequeras
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'concepts'">
							<router-link to="/concepts" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-clipboard-list"></i>
								<p>
									Conceptos
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'companies'">
							<router-link to="/companies" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-id-card-clip"></i>
								<p>
									Empresas
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'bank_accounts'">
							<router-link to="/bank_accounts" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-money-check-dollar"></i>
								<p>
									Cuentas de Bancos
								</p>
							</router-link>
						</li>
						<li class="nav-item" v-can="'inpc'">
							<router-link to="/inpc" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
								<p>
									INPC
								</p>
							</router-link>
						</li>

					</ul>
				</div>
			</li>


			<li class="nav-item" v-can="'rules'">
				<router-link to="/rules" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-pen-ruler"></i>
					<p>
						Reglas
					</p>
				</router-link>
			</li>

			<li class="nav-item" v-can="'permissions'">
				<router-link to="/permissions" active-class="active" class="nav-link">
					<i class="nav-icon fas fa-lock"></i>
					<p>
						Permisos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'tax'">
				<router-link to="/tax" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-cash-register"></i>
					<p>
						Impuestos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'pays_tax'">
				<router-link to="/pays_tax" active-class="active" class="nav-link">
					<i class="nav-icon fas fa-money-check-alt"></i>
					<p>
						Pagar Impuestos
						<span v-can="'pays_tax'" class="float-right badge badge-danger">
							{{ this.catalogue.count_paid_checks_tax }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'vault'">
				<router-link to="/vault" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
					<p>
						Facturas sin Usuario
						<!-- <span v-can="'approve_bill'" class="float-right badge badge-danger">
							{{ this.catalogue.count_bill_check }}
						</span> -->
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'bill'">
				<router-link to="/bill" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
					<p>
						Solicitudes de pago
						<span v-can="'approve_bill'" class="float-right badge badge-danger">
							{{ this.catalogue.count_bill_check }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'download_bill'">
				<router-link to="/bill_download" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
					<p>
						Procesar Facturas
					</p>
				</router-link>
			</li>
			<!-- <li class="nav-item" v-can="'upload_bill'">
				<router-link to="/bill_upload" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-invoice-dollar"></i>
					<p>
						Subir Facturas
					</p>
				</router-link>
			</li> -->
			<li class="nav-item" v-can="'budgets'">
				<router-link to="/budgets" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-coins"></i>
					<p>
						Presupuestos
					</p>
				</router-link>
			</li>

					
			
			<li class="nav-item" v-can="['buy', 'report_buy']">
				<a href="#" class="nav-link" @click.prevent="toggleMenuBuy">
					<i class="nav-icon fa-solid fa-basket-shopping"></i>
					<p>
						Gastos recurrentes
						<i :class="showSubMenuBuy ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenuBuy" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">

						<li class="nav-item" v-can="'buy'">
							<router-link to="/buy" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-basket-shopping"></i>
								<p>
									Gastos recurrentes
								</p>
							</router-link>
						</li>

						<li class="nav-item" v-can="'report_buy'">
							<router-link to="/report_buy" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-list"></i>
								<p>
									Reporte de gastos
								</p>
							</router-link>
						</li>
					</ul>
				</div>
			</li>


			<li class="nav-item" v-can="'checks'">
				<router-link to="/checks" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-receipt"></i>
					<p>
						Órdenes de pago
						<span v-can="'approve_checks'" class="float-right badge badge-danger">
							{{ this.catalogue.count_checks_authorize }}
						</span>
						<span v-if="authUser.organization_charts_id == 3" class="float-right badge badge-danger">
							{{ this.catalogue.count_checks_authorize }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'pays'">
				<router-link to="/pays" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-hand-holding-dollar"></i>
					<p>
						Pagos aprobados
						<span v-can="'add_pays_fast'" class="float-right badge badge-danger">
							{{ this.catalogue.count_paid_checks }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'pays_paid'">
				<router-link to="/pays_paid" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-vault"></i>
					<p>
						Archivo de pagos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'payroll'">
				<router-link to="/payroll" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-file-invoice"></i>
					<p>
						Nominas
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'pay_payroll'">
				<router-link to="/pay_payroll" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-hand-holding-dollar"></i>
					<p>
						Pagar Nóminas
						<span v-can="'add_pays_fast'" class="float-right badge badge-danger">
							{{ this.catalogue.count_paid_payrolls }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'partners'">
				<a href="#" class="nav-link" @click.prevent="toggleMenuShares">
					<i class="nav-icon fa-solid fa-basket-shopping"></i>
					<p>
						Socios
						<i :class="showSubMenuShares ? 'fas fa-angle-down' : 'fas fa-angle-left'" class="right"></i>
					</p>
				</a>
				<div v-if="showSubMenuShares" class="collapse brm show">
					<ul class="nav nav-pills nav-sidebar flex-column">

						<li class="nav-item" v-can="'partners'">
							<router-link to="/partners" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-users"></i>
								<p>
									Reparto a Socios
									<span v-can="'add_pays_fast'" class="float-right badge badge-danger">
										{{ this.catalogue.count_paid_shares }}
									</span>
								</p>
							</router-link>
						</li>

						<li class="nav-item" v-can="'advances'">
							<router-link to="/advances" active-class="active" class="nav-link">
								<i class="nav-icon fa-solid fa-list"></i>
								<p>
									Adelantos
								</p>
							</router-link>
						</li>
					</ul>
				</div>
			</li>

			<!-- <li class="nav-item" v-can="'pay_share'">
				<router-link to="/pay_share" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-hand-holding-dollar"></i>
					<p>
						Pagar Reparto
						<span v-can="'add_pays_fast'" class="float-right badge badge-danger">
							{{ this.catalogue.count_paid_shares }}
						</span>
					</p>
				</router-link>
			</li> -->
			<li class="nav-item" v-can="'income_paid'">
				<router-link to="/income_paid" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-sack-xmark"></i>
					<p>
						Archivo de Ingresos
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'programs'">
				<router-link to="/programs" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-chalkboard-user"></i>
					<p>
						Programas
					</p>
				</router-link>
			</li>		

			<!-- <li class="nav-item" v-can="'incomes'">
				<router-link to="/incomes" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-money-bill-trend-up"></i>
					<p>
						Ingresos
					</p>
				</router-link>
			</li> -->
			<li class="nav-item">
				<router-link to="/profile" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-user-gear"></i>
					<p>
						Editar cuenta
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'report'">
				<router-link to="/report" active-class="active" class="nav-link">
					<i class="nav-icon  fa-solid fa-magnifying-glass-chart"></i>
					<p>
						Reportes
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-if="authUser.organization_charts_id == 1">
				<router-link to="/vacations" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-calendar"></i>
					<p>
						Solicitudes de vacaciones
						<span class="float-right badge badge-danger">
							{{ this.catalogue.count_vacations_check }}
						</span>
					</p>
				</router-link>
			</li>
			<li class="nav-item" v-can="'employee'" v-else>
				<router-link to="/vacations" active-class="active" class="nav-link">
					<i class="nav-icon fa-solid fa-calendar"></i>
					<p>
						Solicitudes de vacaciones
						<span class="float-right badge badge-danger">
							{{ this.catalogue.count_vacations_check }}
						</span>
					</p>
				</router-link>
			</li>
		</ul>
	</nav>
</template>
<style>
.indicator {
	background: red;
	color: #ffffff;
}

.brm {
	margin-top: 5px;
	margin-bottom: 5px;
	border: 1px solid #e6e9f1;
	border-radius: 5px;
}
</style>